<template>
  <div v-if="visible" class="alert-group">
    <div class="alert alert-warning alert-dismissable">
      <div>
        <i class="fa fa-warning" style="color: #EF6C00; font-size: 20px; margin: 5px; margin-right: 10px;"></i>
        <span style="font-size: 14px; font-weight: 600;">Aguardando validação do cadastro</span>
      </div>
      <p style="font-size: 12px; margin-left: 35px">O cadastro foi realizado com sucesso, mas está aguardando
        validação, em até 1 dia útil o seu cadastro será aprovado. É possível que os preços dos produtos estejam
        com valores diferentes. Aguarde a validação para prosseguir com a compra.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertCadastroNaoAtivo',
  props: [
    'visible'
  ]
}
</script>
